import React from "react";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import SelfProfile from "./components/self-profile";
import OtherProfile from "./components/other-profile";

const Profile = () => {
  const { username } = useParams();
  const currentUser = useSelector((state) => state.userPreferences.username);

  return (
    <div id="profile">
      {username && username !== currentUser ? (
        <OtherProfile />
      ) : (
        <SelfProfile />
      )}
    </div>
  );
};

export default Profile;
